import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { GetExtensionDetail_extension_extensionFmFm } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-fmfm-detail-left-column',
    styleUrls: ['./extension-fmfm-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-fmfm-detail-left-column.component.html',
    standalone: false
})
export class ExtensionFmFmDetailLeftColumnComponent {
   @Input() extensionFmFm: GetExtensionDetail_extension_extensionFmFm | null;
}
